"use client";

import { cn } from "@/utils";
import { Loader2Icon } from "lucide-react";
import { useActionState } from "react";
import { Button } from "./button";
import { loopsSubscribe } from "./newsletter.action";

export const LoopsNewsletter = () => {
	const [result, execute, pending] = useActionState(async (state: unknown, formData: FormData) => {
		const result = await loopsSubscribe(formData);
		return result;
	}, null);

	return (
		<form action={execute}>
			<div className="flex flex-row rounded-full p-2 pl-4 gap-2 items-center justify-between border border-neutral-300 h-12 overflow-clip has-[input:focus]:ring-2 ring-brand-500 md:pr-1">
				<input
					className="border-none bg-transparent h-full w-full appearance-none focus:outline-0"
					required
					name="email"
					type="email"
				/>
				<Button
					variant="dark"
					size="small"
					innerClassName={cn("px-3 transition-[width]", pending ? "w-10" : "w-22")}
					type="submit"
				>
					{pending ? <Loader2Icon className="animate-spin" /> : "Subscribe"}
				</Button>
			</div>
			<p className={cn("text-center leading-pregular tracking-pregular text-pregular-500 mt-1 text-sm")}>
				{!result ? " " : result.error ? result.error : "Email added!"}
			</p>
		</form>
	);
};
